import { getPublicMetaData } from 'pricing-pages-lib/api/PublicMetaDataApi';
export const getPromotions = () => {
  return getPublicMetaData();
};